import React from "react";
import styled from "styled-components";
import C from "../../colors";
import PropTypes from "prop-types";
import simpleTransformLocale from "../components/LocaleTransform/simpleTransformLocale";
import Helmet from "react-helmet";
import { FormattedMessage, IntlProvider } from "react-intl";
import LocalizedLink from "../components/localizedLink";
import Navbar from "./navbar";
import { Telegram } from "styled-icons/boxicons-logos";
// Locale data
// import enData from "react-intl/locale-data/en";
// import zhData from "react-intl/locale-data/zh";
// Messages
import en from "../locales/en-US";
import cn from "../locales/cn";
// initialize some things
const messages = { en, cn };

// addLocaleData([...enData, ...zhData]);

const WhiteTelegram = styled(Telegram)`
  color: white;
  width: 18px;
  height: 18px;
  padding-bottom: 2px;
`;

const Page = styled.div`
  .tg-badge{
    display:flex;
    flex-wrap: nowrap
  }

  .green {
    color: ${C.lightgreen};
  }

  color: ${C.gray};
  font-size: 14px;
  font-family: "DM Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,
    Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";

  *:focus {
    outline: none;
  }

  // temporary to avoid messy mobile version.
  .marketcap-link {
    @media (max-width: 450px) {
      /* display: none !important; */
    }
  }

  .container {
    padding-top:0px !important;
    margin: 0 auto;
    width: 96%;
    max-width: 1200px;
  }
  .header {
    display: flex;
    margin: 50px 0 30px;
    @media (max-width: 600px) {
      margin-top: 20px;
      margin-bottom: 08px;
    }
    img {
      display: inline-block;
      margin-right: 30px;
    }
    .header-left,
    .header-right {
      width: 50%;
    }
    .header-right {
      text-align: right;
      margin-top: 5px;
      a {
      }

      @media (max-width: 600px) {
        margin: 40px 0;
      }
    }

    /* a {
      color: ${C.dark};
      margin-right: 20px;
      font-weight: bold;
      margin-top: 5px;
      display: inline-block;
      vertical-align: top;

      &.active {
        // text-decoration: underline;
        border-bottom: 2px solid;
      }
      &:hover {
        text-decoration: none;
      }
    } */

    /* .logo-link {
      cursor: pointer;
      padding-left: -100px !important;
    } */
  }
  .notice-box {
    margin-bottom: 30px;
    background: linear-gradient(135deg, ${C.darkergreen}, ${C.darkergreen} 20%, ${C.blue2} 90%, ${C.blue} 100%);
    border-radius: 4px;
    color: ${C.darkergreen};
    padding: 2px;
    .notice-box-inner {
      background: rgba(0,0,0,0.75);
      padding: 12px 18px;
      border-radius: 2px;
    }
    strong {
      font-weight: 600;
    }
    a {
      color: ${C.lightgreen};
      font-weight: bold;
      text-decoration: underline;
      &:hover {
        opacity: 0.75;
      }
    }
  }
  @media (max-width: 600px) {
    h1 {
      font-size: 2rem;
    }
  }

  @media (max-width: 850px) {
    /* fixing sticky ads on desktop not working */
    overflow:hidden !important;

    #tg-badge{
    position: fixed;
      z-index: 1000;
      bottom: 5rem;
      right: 16px;
  }

    .tg-badge {
      background: #08c;
      padding: 8px 15px 8px 8px;
      border-radius: 40px;
      transition: all 0.1s;
      cursor: pointer;
      line-height: 1;
      color: #fff;
      font-weight: 700;
      &:hover {
        text-decoration: none;
        background: #19d;
      }
      img {
        margin-right: 10px;
        width: 22px;
        height: 22px;
        border: 1px solid #6be;
        border-radius: 1000px;
      }
      span,
      img {
        vertical-align: middle;
      }
    }
  }

  .title {
    color: ${C.gray};
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 10px;
  }
  .row-flex {
    display: flex;
    margin: 0 -6px;
    flex-wrap: wrap;
    margin-bottom: 32px;
    & > * {
      margin: 0 6px;
      margin-bottom: 12px;
    }
  }

  footer {
    margin: 38px 0 100px 0;
    border-top: 1px solid ${C.THEME ? C.dark : C.light};
    padding: 10px 0;
    padding-bottom: 0px;
    margin-bottom: 40px;
    bottom: 0px;

    .general-info-link {
      float: left;
      color: ${C.THEME ? C.dark : C.light};
      text-decoration: underline;
    }
  }

  .hide {
    display: none !important;
  }

  @media (min-width: 850px) {
    #tg-badge{
    display: flex;
    position: fixed;
    z-index: 1000;
    bottom: 2rem;
    right: 16px;
  }
    .tg-badge {
      background: #08c;
      padding: 8px 15px 8px 8px;
      border-radius: 40px;
      transition: all 0.1s;
      cursor: pointer;
      line-height: 1;
      color: #fff;
      font-weight: 700;
      &:hover {
        text-decoration: none;
        background: #19d;
      }
      img {
        margin-right: 10px;
        width: 22px;
        height: 22px;
        border: 1px solid #6be;
        border-radius: 1000px;
      }
      span,
      img {
        vertical-align: middle;
      }
    }

  }

  .telegram-close {
    transition: opacity 0.5s ease;
    position: absolute;
    left:145px;
    bottom: 1.6rem;
        z-index: 1001;
        background-color:${C.darker};
        color:white;
        font-weight:700;
        width: 25px;
        height:20px;
        border-radius: 400px;
        text-align: center;
        padding-bottom:24px;
    cursor: pointer;
    opacity: 30%;

    &:hover{
      opacity: 100%;
    }
      }
`;

const AMPpage = styled.div`
  a {
    margin-right: 20px;
    font-weight: bold;
    margin-top: 5px;
    display: inline-block;
    vertical-align: top;

    &.active {
      // text-decoration: underline;
      border-bottom: 2px solid;
    }
    &:hover {
      text-decoration: none;
    }
  }

  .logo-link {
    width: 140px !important;
  }

  @media (max-width: 850px) {
    .tg-badge {
      position: fixed;
      z-index: 1000;
      bottom: 4rem;
      right: 16px;
      background: #08c;
      padding: 8px 15px 8px 8px;
      border-radius: 40px;
      transition: all 0.1s;
      cursor: pointer;
      line-height: 1;
      color: #fff;
      font-weight: 700;
      &:hover {
        text-decoration: none;
        background: #19d;
      }
      img {
        margin-right: 10px;
        width: 18px;
        height: 18px;
        border: 1px solid #6be;
        border-radius: 1000px;
      }
      span,
      img {
        vertical-align: middle;
      }
    }
  }

  @media (min-width: 850px) {
    .tg-badge {
      position: fixed;
      z-index: 1000;
      bottom: 2rem;
      right: 16px;
      background: #08c;
      padding: 8px 15px 8px 8px;
      border-radius: 40px;
      transition: all 0.1s;
      cursor: pointer;
      line-height: 1;
      color: #fff;
      font-weight: 700;
      &:hover {
        text-decoration: none;
        background: #19d;
      }
      img {
        margin-right: 10px;
        width: 18px;
        height: 18px;
        border: 1px solid #6be;
        border-radius: 1000px;
      }
      span,
      img {
        vertical-align: middle;
      }
    }
  }
`;

const Layout = ({ locale, children, contentfulID, ampMode }) => {
  const dateNow = Date.now();
  const renderPageContent = () => {
    if (ampMode === "amp") {
      return (
        <AMPpage>
          <IntlProvider
            locale={locale}
            messages={messages[simpleTransformLocale(locale)]}
          >
            <>
              <Helmet>
                {/* <link rel="stylesheet" href="/css/bootstrap-amp.min.css" /> */}

                {/* <title> { 'EOS GO - ' + (props.title || 'Market Cap') } </title> */}
              </Helmet>

              <div className="container">
                <div className="header">
                  <div className="header-left">
                    <LocalizedLink to="/">
                      <img
                        className="logo-link"
                        src="/img/logo-dark.png"
                        alt="EOS Go Logo"
                      />
                    </LocalizedLink>

                    {/* <LocalizedLink
                      to="/marketcap/"
                      activeClassName="active"
                      className="marketcap-link"
                    >
                      <FormattedMessage id="menu-marketcap" />
                    </LocalizedLink> */}
                    <LocalizedLink to="/blog" activeClassName="active">
                      <FormattedMessage id="menu-blog" />
                    </LocalizedLink>
                    <LocalizedLink to="/news" activeClassName="active">
                      <FormattedMessage id="menu-news" />
                    </LocalizedLink>
                  </div>
                </div>

                {children}

                <a
                  href="https://t.me/eosgo"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tg-badge"
                >
                  <span>
                    <WhiteTelegram /> <FormattedMessage id="telegram-cta" />
                  </span>
                </a>
              </div>
            </>
          </IntlProvider>
        </AMPpage>
      );
    } else {
      return (
        <Page>
          <IntlProvider
            locale={locale}
            messages={messages[simpleTransformLocale(locale)]}
          >
            <>
              <Helmet>
                <link rel="stylesheet" href="/css/bootstrap.min.css" />
                {/* <title> { 'EOS GO - ' + (props.title || 'Market Cap') } </title> */}
              </Helmet>

              <div className="container">
                <Navbar
                  contentfulID={contentfulID}
                  locale={locale}
                  ampMode="none"
                ></Navbar>
                {children}

                <footer>
                  {/* <FormattedMessage id="footer-maintained" />{" "}
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://t.me/eosasia"
                  >
                    <FormattedMessage id="footer-owner" />
                  </a>
                  <FormattedMessage id="footer-token-price-source" />{" "}
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://newdex.io"
                  >
                    <FormattedMessage id="footer-api-source" />
                  </a>

                  Token prices from <a target="_blank" href="https://newdex.io/">NEWDEX</a>. */}
                  <a className="general-info-link" href="/info">
                    {" "}
                    <FormattedMessage id="footer-general-info" />
                  </a>
                </footer>
                {/* displaying the join community button only if not being hidden before. */}
                {typeof window !== "undefined" && (
                  <div>
                    {(!window.localStorage.getItem("no-tg-badge") ||
                      (window.localStorage.getItem("no-tg-badge") &&
                        dateNow - window.localStorage.getItem("no-tg-badge") >
                          172800)) && ( //if the badge has been hidden for 48 hours
                      <div id="tg-badge">
                        {window.localStorage.removeItem("no-tg-badge")}
                        <a
                          href="https://t.me/eosgo"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="tg-badge"
                        >
                          <img
                            alt="telegram_share"
                            height="18"
                            width="18"
                            src="/img/telegram.png"
                          />
                          <span style={{ marginTop: "2px" }}>
                            <FormattedMessage id="telegram-cta" />
                          </span>
                        </a>
                        <span
                          className="telegram-close"
                          onClick={() => {
                            const target = document.getElementById("tg-badge");
                            target.classList.add("hide");
                            localStorage.setItem("no-tg-badge", Date.now());
                          }}
                        >
                          <p>x</p>
                        </span>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </>
          </IntlProvider>
        </Page>
      );
    }
  };

  return renderPageContent();
};

Layout.propTypes = {
  locale: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default Layout;
